let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
let BillItemCollection = require("../collection/BillItemCollection.js");
let PaymentCollection = require("../collection/PaymentCollection.js");
let DbRecorder = require("../recorder/DbRecorder.js");
let {uuid} = require("../utils/utils.js");
let moment = require('moment');
let DiscountModel = require("./DiscountModel.js");


let main = function () {
    return Backbone.Model.extend({
        defaults: {
            items: null, //订单项集合
            unconfirmedItems: null, //未确认订单项集合
            lastUpdated: (function () {
                return new Date().getTime();
            })(), //最后更新时间
            checkInTime: 0, //
            changeAmount: 0, //找零金额
            confirmed: true, //是否已确认
            dinerCount: 1, //用餐人数
            offDiscountAmount: 0, //打折金额
            feeAmount: 0, //服务费金额
            noFee: false,//免去服务费
            originalFeeAmount: 0,//初始服务金额
            ignoreAmount: 0,//抹零
            tipAmount: 0,//小费
            refundAmount: 0,//退款金额
            orderAmount: 0, //账单金额
            leftOrderAmount: 0, //剩余需付款订单金额
            discountedAmount: 0, //折扣金额
            originalShouldPayAmount: 0, //初始应支付金额
            paidAmount: 0, //支付金额
            payStatus: "Unpaid", //支付状态
            refundStatus: "None", //退单状态　Total:全退　None:没有退单　Has:部分退单
            payments: null, //付款信息
            postageAmount: 0, //快递费用
            status: "Queue", //订单状态
            discount: null, //打折model
            uuid: null, //client side generated unique id
            tags: null, //使用的标签
            orderDate: 0, //下单时间
            waiter: null, //服务员ID
            payDate: 0, //支付时间
            version: 0, //服务器版本
            serial: 0, //订单序号
            invoiceNO: [], //发票编号
            taxId: null, //客户统一编码
            printed: false,//是否打印过
            billRePrint: {
                Statement: 0,
                Receipt: 0,
                EachItem: 0,
                RefundItem: 0,
                DisPatch: 0,
                RefundAmount: 0
            }
        },

        url: "/bill/save",

        /*
         * 初始化订单
         */
        initialize: function (params) {
            var self = this;
            params = params || {};
            this.set({items: new BillItemCollection(params.items || [])});
            this.set({unconfirmedItems: new BillItemCollection(params.unconfirmedItems || [])});
            var _payments = new PaymentCollection(params.payments || []);
            this.set({
                payments: _payments
            });

            var oldUUID = null;

            if (!$.isEmptyObject(params)) {
                if (params.hasOwnProperty('uuid')) {
                    oldUUID = params.uuid;

                } else if (params.get != undefined && params.get('uuid')) {
                    oldUUID = params.get('uuid');
                }
            }

            if (oldUUID) {
                this.set('uuid', oldUUID);
                this.set('shortUUID', this.getShortUUID(oldUUID));
            } else {
                var uid = uuid();
                this.set('uuid', uid);
                this.set('shortUUID', this.getShortUUID());
            }

            self.calculateAmount();
            self.calculateRefund();

            //listen to billModel
            self.on("change:discount", self._onDiscountChange, self);
            self.on("change:dinerCount", self._onDinerCountChange, self);
            self.on("change:ignoreAmount", self.calculateAmount, self);
            self.on("change:tipAmount", self.calculateAmount, self);
            //listen to every item of the bill
            self.getBillItems().forEach(function (model) {
                model.on("change:shouldRefund", function () {
                    self.calculateAmount();
                    self.calculateRefund();
                    if (model.get('shouldRefund')) {
                        self.set({refundTime: new Date().getTime()});
                    }
                });
                model.on("change", function () {
                    self.set({lastUpdated: new Date().getTime()});
                });
            });
            //listen to billItemCollection
            if (params.discount) {
                self.set({discount: new DiscountModel(params.discount)});
            }
            var monitorBillItem = function (model) {
                if (!self.getCheckInTime()) {
                    self.set({checkInTime: new Date().getTime()});
                }
                self.set({lastUpdated: new Date().getTime()});
                model.on("change", function () {
                    self.set({lastUpdated: new Date().getTime()});
                });
                model.on("change:shouldRefund", function () {
                    self.calculateAmount();
                    self.calculateRefund();
                    if (model.get('shouldRefund')) {
                        self.set({refundTime: new Date().getTime()});
                    }
                });
                self.calculateAmount();
                self.calculateRefund();
            };

            self.getBillItems().on("add", (model) => {
                monitorBillItem(model);
            });
            self.getBillItems().on("reset", (col) => {
                col.forEach(monitorBillItem);
            });

            //listen to status change event of billModel
            self.on("change:status", function () {
                self.isCompleted();
            });

            if (self.isEmpty()) {
                this.resetCheckInTime();
            }

            if (!self.get("sid")) {
                self.set("sid", new moment(new Date(self.get('checkInTime'))).format("YYMMDDHHmmssSSS"));
            }

        },

        _onIgnoreAmountChange: function () {

        },

        /*
         *　重新计算并设置折扣信息　
         */
        _onDiscountChange: function () {
            var self = this, discount = self.get("discount");
            var offDiscountAmount = 0, offDiscountOriginalAmount = 0;
            self.set("offDiscountAmount", 0);
            self.set("offDiscountOriginalAmount", 0);
            self.getBillItems().forEach(function (billItem) {
                billItem.unset("offDiscountAmount");
                billItem.unset("offDiscountOriginalAmount");
                billItem.unset("discountedPrice");
                billItem.unset("discount");
            });
            if (discount) {
                console.log("discount", discount);
                switch (discount.get("type")) {
                    case "Amount":
                        if (discount.get("uses") != null && discount.get("uses").length > 0) {
                            self.getBillItems().forEach(function (billItem) {
                                if (discount.canApplyTo(billItem.get("menuItem"))) {
                                    offDiscountAmount += billItem.getDiscountedAmount();
                                    if (offDiscountAmount > discount.get('off')) {
                                        offDiscountAmount = discount.get('off');
                                    }
                                }
                            });
                        } else {
                            offDiscountAmount = discount.get('off');
                        }
                        break;
                    case "Percentage":
                        self.getBillItems().forEach(function (billItem) {
                            if (discount.canApplyTo(billItem.get("menuItem"))) {
                                var discountedPrice = discount.calculateDiscountedPrice(billItem.get("price"));
                                billItem.set("discountedPrice", discountedPrice);
                                offDiscountAmount = parseFloat((billItem.get('price') - discountedPrice) * billItem.get('orderedQuantity').toFixed(2));
                                offDiscountOriginalAmount = parseFloat((billItem.get('price') - discountedPrice) * billItem.get('quantity').toFixed(2));
                                billItem.set("offDiscountAmount", offDiscountAmount);
                                billItem.set("offDiscountOriginalAmount", offDiscountOriginalAmount);
                                offDiscountAmount += parseFloat(billItem.getOffDiscountedAmount());
                            }
                        });
                        break;
                    default:
                        break;
                }
                self.set("offDiscountAmount", offDiscountAmount);
                self.set("offDiscountOriginalAmount", offDiscountOriginalAmount);
            }
            self.calculateAmount();

        },

        resetItemsDiscount: function () {
            $.each(this.get("items").models, function (index, item) {
                item._unsetDiscount();
            });
        },
        recalculateItemsDiscount: function () {
            $.each(this.get("items").models, function (index, item) {
                item._onDiscountChange();
            });
        },
        checkSingeDiscount: function () {
            var hasDiscount = false;
            $.each(this.get("items").models, function (index, item) {
                if (item.get("discount")) {
                    hasDiscount = true;
                }
            });
            return hasDiscount;
        },

        getBillItems: function () {
            return this.get("items");
        },

        getPackItemsFromPackId:function(packageId){
            var unPackItems = new Backbone.Collection();
            $.each(this.get("items").models, function (index, item) {
                if (item.get("packageId") == packageId) {
                    unPackItems.add(item);
                }
            });
            return unPackItems;
        },

        getBillUnPackItems: function () {
            var unPackItems = new Backbone.Collection();
            $.each(this.get("items").models, function (index, item) {
                if (item.get("packageId") && item.get("packageOptionName")) {
                    return;
                }
                unPackItems.add(item);
            });
            return unPackItems;
        },

        resetCheckInTime: function () {
            this.set({checkInTime: new Date().getTime()});
        },

        setOrderDate: function () {
            this.set({orderDate: new Date().getTime()});
        },
        setPayDate: function () {
            this.set({payDate: new Date().getTime()});
        },
        /*
         * 计算并设置订单相关金额
         */
        calculateAmount: function () {
            var self = this, orderAmount = 0, discount = self.get("discount"), singeDiscount = false,
                restaurant = self.get("restaurant"),
                roundType = null,
                singeAmountTotal = 0,
                leftOrderAmount = 0,
                paidAmount = 0,
                shouldPayAmount = 0,
                offDiscountAmount = 0,
                originalShouldPayAmount = 0,
                offDiscountOriginalAmount = 0,
                discountedAmount = 0,
                originalFeeAmount = 0,
                ignoreAmount = 0,
                tipAmount = 0,
                feeAmount = self.get("feeAmount"),
                payAmount = 0,  //实际支付金额
                refundAmount = 0,
                discountRefundAmount = 0,
                postageAmount = 0,
                roundAmount = 0;
            this.set({noFee: this.get("noFee") || this.get("shippingRecord") != null});
            self.getBillItems().forEach(function (billItem) {
                if (billItem.get('discount')) {
                    singeDiscount = true;   //有单品折扣
                }
                payAmount += billItem.getOriginalAmount();      //账单金额
                offDiscountAmount += billItem.getOffDiscountedAmount();    //单品折扣金额
                singeAmountTotal += billItem.getDiscountIsAmountTotal();       //单品减现金额
                discountedAmount += billItem.getDiscountedAmount();  //单品折扣金额
                offDiscountOriginalAmount += billItem.getOffDiscountedOriginalAmount();
                orderAmount += billItem.getOriginalAmount();   //包含退菜总金额
                //payAmount是用于服务费的计算，账单中只要出现退餐情况，不管是付款前或者付款后退餐，payAmount都应减去所退餐品的标价

            });
            discount = discount ? discount = DbRecorder.convert2JSON(discount) : null;
            if (discount && discount.type == "Amount") {
                offDiscountAmount = self.get('offDiscountAmount');
            }
            if (restaurant) {
                roundType = restaurant.roundType;
                var fee = restaurant.fee ? restaurant.fee : 0;
                if (1 > fee && fee > 0) {
                    //折前服务费
                    originalFeeAmount = parseFloat((payAmount * fee).toFixed(2));
                    //计算折后服务费
                    if (discount) {
                        if (discount.type == "Percentage") {
                            feeAmount = originalFeeAmount;
                            feeAmount = feeAmount * (100 - discount.off) / 100;
                        } else if (discount.type == "Amount") {
                            if (self.getRefundStatus() != "Total") {
                                feeAmount = originalFeeAmount;
                                feeAmount = feeAmount - parseFloat((discount.off * fee).toFixed(2));
                            } else {
                                feeAmount = 0
                            }
                        }
                    } else if (singeDiscount) {
                        feeAmount = originalFeeAmount;
                        feeAmount -= parseFloat((offDiscountAmount * fee).toFixed(2));
                    } else {
                        feeAmount = originalFeeAmount;
                    }
                }
            }
            refundAmount = self.getRefundAmount();
            ignoreAmount = self.get("ignoreAmount");
            tipAmount = self.get('tipAmount');
            postageAmount = self.get('postageAmount');
            if (!self.get('noFee')) {
                discountedAmount = discountedAmount + feeAmount;      //折后金额 = 餐品折后金额+服务费折后金额
            }
            //如果是百分比折扣或者没有折扣，应付金额 = 折后金额 - 抹零金额
            //shouldPayAmount = discountedAmount - ignoreAmount;
            //如果是固定折扣 应付金额 = 折后金额 - 抹零金额 - 折扣金额；
            shouldPayAmount = discountedAmount - ignoreAmount - singeAmountTotal + tipAmount + postageAmount;
            if (discount) {
                if (discount.type == "Amount") {
                    shouldPayAmount = discountedAmount - ignoreAmount - offDiscountAmount + tipAmount;
                    if (shouldPayAmount < 0) {
                        shouldPayAmount = 0
                    }
                }
            }
            if (self.getRefundStatus() == "Total") {
                refundAmount = refundAmount - ignoreAmount;
                refundAmount += postageAmount;
                if (discount) {
                    if (discount.type == "Amount") {
                        refundAmount = refundAmount - offDiscountAmount;    //如果是固定折扣的退单，则退款金额还要减去折扣金额
                        if (!self.get('noFee')) {
                            refundAmount = refundAmount - offDiscountAmount * restaurant.fee;    //如果是固定折扣的退单，则退款金额还要减去折扣金额的服务费
                        }
                        if (refundAmount < 0) {
                            refundAmount = 0
                        }
                    }
                }
                shouldPayAmount = 0;                        //如果是退单，则应付金额 = 0
            }
            originalShouldPayAmount = shouldPayAmount;
            self.get("payments").forEach(function (payment) {
                shouldPayAmount -= payment.get("amount");
                paidAmount += payment.get("amount");
                if (discount && discount.type == "Amount" && payment.get("type") == "Refund") {
                    discountRefundAmount += payment.get('amount');
                }
            });
            if (discount && discount.type == "Amount" && discountRefundAmount < 0) {
                shouldPayAmount += discountRefundAmount;
            }
            if (self.getRefundStatus() == "Total") {
                shouldPayAmount = 0;
                paidAmount = 0;
            }
            if (shouldPayAmount < 0) {
                shouldPayAmount = 0;
            }
            roundAmount = (shouldPayAmount - self.roundShouldPay(shouldPayAmount, roundType ? roundType : "Fixed")).toFixed(2);
            shouldPayAmount = self.roundShouldPay(shouldPayAmount, roundType ? roundType : "Fixed");
            if (shouldPayAmount == 0.01) {                  //允许0.01的误差(解决百分比折扣退单之后，桌面显示金额出现0.01或者0.01的倍数的情况)
                shouldPayAmount = 0;
            }
            originalShouldPayAmount = self.roundShouldPay(originalShouldPayAmount, roundType ? roundType : "Fixed");

            var payStatus = shouldPayAmount > self.roundShouldPay(shouldPayAmount, roundType ? roundType : "Fixed") ? "Unpaid" : "Paid";
            self.set(
                {
                    orderAmount: orderAmount, leftOrderAmount: payAmount,
                    paidAmount: paidAmount, shouldPayAmount: shouldPayAmount,
                    originalShouldPayAmount: originalShouldPayAmount,
                    discountedAmount: discountedAmount,
                    changeAmount: (0 - shouldPayAmount),
                    payStatus: payStatus,
                    originalFeeAmount: originalFeeAmount,
                    feeAmount: feeAmount,
                    offDiscountAmount: offDiscountAmount,
                    offDiscountOriginalAmount: offDiscountOriginalAmount,
                    roundAmount: roundAmount,
                    refundAmount: self.roundShouldPay(refundAmount, roundType ? roundType : "Fixed")
                }
            );
        },

        /*
         *  按照设置取最后应付金额
         */
        roundShouldPay: function (amount, type) {
            switch (type) {
                case "Floor":
                    return Math.floor(amount);
                    break;
                case "Ceil":
                    return Math.ceil(amount);
                    break;
                case "Round":
                    return Math.round(amount);
                    break;
                default :
                    return parseFloat((amount + 0.004).toFixed(2));
                    break;
            }
        },

        /*
         * 设置订单的退单状态
         */
        calculateRefund: function () {
            var self = this, has = false, total = false;
            if (self.getBillItems().length == 0) {
                self.set({refundStatus: 'None'});
                return;
            }
            has = self.getBillItems().any(function (item) {
                return item.getOrderedQuantity() == 0;
            });
            total = self.getBillItems().every(function (item) {
                return item.getOrderedQuantity() == 0;
            });
            if (total) {
                self.set({refundStatus: "Total"});
            } else if (has) {
                self.set({refundStatus: "Has"});
            } else {
                self.set({refundStatus: "None"});
            }
        },
        //这里获得的退款金额为 餐品+服务费 的退款金额
        getRefundAmount: function () {
            var self = this, refundAmount = 0, discount = DbRecorder.convert2JSON(self.get("discount"));
            self.getBillItems().forEach(function (billItem) {
                var refundQuantity = billItem.get("refundQuantity");
                var unPaidRefundQuantity = billItem.get("unPaidRefundQuantity");
                //当billitem的状态为已经付款且退餐数量大于0时才会进行退款的计算
                if ((refundQuantity - unPaidRefundQuantity) > 0 && billItem.get("paid")) {
                    //对于使用了折扣的餐品 ，计算折后价 ，对于没有使用折扣的餐品 ，计算原价
                    var discount = DbRecorder.convert2JSON(billItem.get("discount"));
                    var paidRefundQuantity = refundQuantity - unPaidRefundQuantity;
                    if (billItem.get("discountedPrice")) {
                        refundAmount += paidRefundQuantity * billItem.get("discountedPrice");
                    } else {
                        refundAmount += paidRefundQuantity * billItem.get("price");
                    }
                    if (discount && discount.type == "Amount") {
                        refundAmount -= discount.off;
                    }
                }
            });
            //计算所退服务费的金额
            var restaurant = self.get("restaurant");
            if (restaurant) {
                var fee = restaurant.fee ? restaurant.fee : 0;
                if (100 > fee > 0) {
                    if (!self.get('noFee')) {
                        refundAmount += parseFloat((refundAmount * fee).toFixed(2));
                    }
                }
            }
            self.set({refundAmount: refundAmount});
            return refundAmount;
        },
        recordRePrintCount(printType) {
            this.get("billRePrint")[printType] = ++this.get("billRePrint")[printType];
        },
        getUnconfirmedItems: function () {
            return this.get("unconfirmedItems");
        },
        getUnconfirmedQuantity: function () {
            var quantity = 0;
            this.get("unconfirmedItems").forEach((item) => {
                quantity = quantity + item.get("quantity");
            });
            return quantity;
        },
        getUnconfirmedTotal: function () {
            var amount = 0;
            this.getUnconfirmedItems().forEach(function (item) {
                amount += item.getAmount();
            });
            return amount;
        },
        getConfirmedItems: function () {
            var self = this, confirms = [];
            self.getBillItems().forEach(function (item) {
                if (item.isConfirmed()) {
                    confirms.push(item);
                }
            });
            return confirms;
        },
        getConfirmedTotal: function () {
            var amount = 0;
            if (this.getConfirmedItems().length == 0) {
                return amount;
            }

            _.each(this.getConfirmedItems(), function (item) {
                amount += item.getAmount();
            });
            return amount;
        },
        getUnSavedItems: function () {
            return _.filter(this.getBillItems().models, function (item) {
                return !item.id;
            });
        },
        getNeedPayItems: function () {
            return this.getConfirmedItems();
        },
        getPaidItems: function () {
            var self = this, paid = [];
            self.getBillItems().forEach(function (item) {
                if (item.isPaid()) {
                    paid.push(item);
                }
            });
            return paid;
        },
        getPaidTotal: function () {
            var amount = 0;
            _.each(this.getPaidItems(), function (item) {
                amount += item.getAmount();
            });
            return amount;
        },
        hasPaid: function () {
            return this.isPaid();
        },
        getCheckInTime: function () {
            return this.get("checkInTime");
        },

        isEmpty: function () {
            return this.getBillItems().length == 0;
        },

        isThirdParty: function () {
            var self = this, paid = true;
            return self.get("status") == "ThirdParty";
        },

        isPaid: function () {
            var self = this, paid = true;
            self.getBillItems().forEach(function (billItem) {
                paid = paid && billItem.isPaid();
            });
            return paid && self.getBillItems().length > 0;
        },
        pleaseComplete: function () {
            console.log("XXXXX pleaseComplete XXXXXX");
            this.set({shouldComplete: true, shouldCompleteTime: new Date().getTime()});
        },

        markComplete: function () {
            this.unset("shouldComplete");
            this.set({status: "Completed"});
        },

        isPrepareForComplete: function () {
            return this.get("shouldComplete");
        },

        isCompleted: function () {
            return (this.get("status") == "Completed" || this.get("shouldComplete")) && this.isPaid();
        },

        pleaseCancel: function () {
            this.set({shouldCancel: true, shouldCancelTime: new Date().getTime()});
        },

        markCancel: function (status) {
            this.unset("shouldCancel");
            this.set({status: status ? status : "Cancel"});
        },

        isPrepareForCancel: function () {
            return this.get("shouldCancel");
        },

        isCanceled: function () {
            return (this.get("status") === "Cancel") || this.get("shouldCancel");
        },

        pleaseMove: function (table) {
            this.set({shouldMove: true, shouldMoveTime: new Date().getTime(), shouldMoveToTableId: table.id});
        },

        markMove: function () {
            this.unset("shouldMove");
            this.unset("shouldMoveToTableId");
        },

        isPrepareForMove: function () {
            return this.get("shouldMove") != null;
        },

        pleaseConfirm: function () {
            this.getBillItems().forEach(function (billItem) {
                if (!billItem.isConfirmed()) {
                    billItem.confirm();
                }
            });
            this.set({shouldConfirm: true, shouldConfirmTime: new Date().getTime(), status: 'Queue'});
        },

        markConfirm: function (status) {
            this.unset("shouldConfirm");
            this.set({status: status ? status : "Queue"});
        },

        isConfirmed: function () {
            var confirmed = ($.inArray(this.get("status"), ["PreOrder", "Ordering", "Cancel", "ThirdParty"]) == -1);
            return confirmed || this.get("shouldConfirm");
        },

        isPrepareForConfirm: function () {
            return this.get("shouldConfirm");
        },

        getOriginalAmount: function () {
            return this.get("orderAmount");
        },

        /**
         * return bill should pay amount
         */
        getShouldPayAmount: function () {
            return this.get("shouldPayAmount");
        },

        /**
         *  return bill original should pay amount
         */
        getOriginalShouldPayAmount: function () {
            return this.get("originalShouldPayAmount");
        },
        /*
         * 取消订单
         */
        cancel: function () {
            this.set('status', 'CANCEL_REQUESTED');
            this.trigger('CANCEL');
        },

        getMaxPriority: function () {
            var priority = 0, exitPriority;
            this.getBillItems().forEach(function (item) {
                exitPriority = item.get("priority");
                if (exitPriority && exitPriority > priority) {
                    priority = exitPriority;
                }
            });
            this.getUnconfirmedItems().forEach(function (item) {
                exitPriority = item.get("priority");
                if (exitPriority && exitPriority > priority) {
                    priority = exitPriority;
                }
            });
            return priority;
        },
        /*
         * 全部退单
         */
        refundAll: function (reason) {
            var self = this;
            self.getBillItems().forEach(function (model) {
                var paid = model.get("paid");
                var refundQuantity = model.get("refundQuantity");
                model.set({shouldRefund: true}, {silent: true});
                model.set({refundQuantity: model.get("quantity")});
                model.set({shouldRefundQuantity: model.get("quantity") - refundQuantity});
                if (!paid) {
                    model.set({unPaidRefundQuantity: model.get("quantity")});
                }
            });
            self.calculateRefund();
            self.calculateAmount();
            self.set({
                refundReason: reason,
                refundStatus: "Total",
                refundTime: new Date().getTime(),
                lastUpdated: new Date().getTime()
            });
        },
        getRefundStatus: function () {
            return this.get("refundStatus");
        },
        getProcessing: function () {
            return this.processing;
        },
        setProcessing: function () {
            this.processing = true;
        },
        unsetProcessing: function () {
            if (this.processing) {
                delete this.processing
            }
        },

        getSID: function () {
            var sid = this.get('sid');

            if (sid.length > 12) {
                //this is a client side generated sid, we return short uuid instead
                return this.getShortUUID();
            } else {
                //this is a server side generated sid, we can use it safely
                return sid;
            }
        },

        getShortUUID: function (uuid) {
            if (uuid != undefined && uuid.length > 5) {
                return uuid.substring(0, 5).toUpperCase();
            }
            //this should be unique within 1000 bills, unique enough for 1 day
            return this.get('uuid').substring(0, 5).toUpperCase();
        }
    });
};

let exportedValue = main();
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/model/BillModel.js